(function () {
  var STORAGE_KEY = 'ela_wishlist';
  var LEAD_KEY = 'ela_wishlist_lead';
  var LEAD_EMAIL = 'ela_wishlist_email';
  var pendingProduct = null;
  var modal = null;
  var form = null;
  var submitBtn = null;

  function readWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function isWishlisted(handle) {
    return readWishlist().some(function (item) {
      return item.handle === handle;
    });
  }

  function addToWishlist(product) {
    var list = readWishlist();
    if (!list.some(function (item) { return item.handle === product.handle; })) {
      list.push(product);
      saveWishlist(list);
    }
  }

  function removeFromWishlist(handle) {
    saveWishlist(
      readWishlist().filter(function (item) {
        return item.handle !== handle;
      })
    );
  }

  function hasLead() {
    try {
      return localStorage.getItem(LEAD_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function setLead(email) {
    try {
      localStorage.setItem(LEAD_KEY, '1');
      // Their own address, in their own browser. Kept so that the SECOND and
      // every later product they save can be recorded against them too: the
      // modal only appears once, so without this every save after the first
      // would be anonymous and the list would show one product per person.
      if (email) localStorage.setItem(LEAD_EMAIL, email);
    } catch (e) {}
  }

  function leadEmail() {
    try {
      return localStorage.getItem(LEAD_EMAIL) || '';
    } catch (e) {
      return '';
    }
  }

  function getProductFromButton(btn) {
    return {
      handle: btn.dataset.handle,
      url: btn.dataset.url,
      img: btn.dataset.img,
      title: btn.dataset.title,
      price: btn.dataset.price
    };
  }

  function setHeartState(btn, active) {
    if (active) {
      btn.classList.add('is-active');
    } else {
      btn.classList.remove('is-active');
    }
  }

  function refreshHeartStates(root) {
    var scope = root || document;
    var hearts = scope.querySelectorAll('.ela-wishlist-heart');
    hearts.forEach(function (btn) {
      setHeartState(btn, isWishlisted(btn.dataset.handle));
    });
  }

  function getModalEls() {
    if (!modal) {
      modal = document.getElementById('ela-wishlist-modal');
      form = modal && modal.querySelector('form');
      submitBtn = form && form.querySelector('.ela-wishlist-modal__submit');
      if (form) {
        // Post without the default #anchor so a native fallback can't
        // anchor-jump the page (e.g. to the footer newsletter form).
        form.action = form.action.split('#')[0];
        // Bind directly on the form: runs before any document-level theme
        // handlers, so the popup can never trigger a full page load.
        form.addEventListener('submit', handleSubmit);
      }
    }
    return modal;
  }

  function openModal() {
    if (!getModalEls()) return;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = '';
    pendingProduct = null;
  }

  // Capture phase: runs before the theme's own click handlers, so clicking
  // the heart can never trigger the card's navigation or other theme logic.
  document.addEventListener(
    'click',
    function (e) {
      var heart = e.target.closest('.ela-wishlist-heart');
      if (heart) {
        e.preventDefault();
        e.stopPropagation();
        var product = getProductFromButton(heart);

        if (isWishlisted(product.handle)) {
          removeFromWishlist(product.handle);
          setHeartState(heart, false);
          return;
        }

        if (hasLead()) {
          addToWishlist(product);
          setHeartState(heart, true);
          // They gave us their address the first time and the modal will never
          // open for them again, so this is the only chance to record every
          // product after that one.
          recordWishlistSignup(leadEmail(), '', product);
          return;
        }

        pendingProduct = product;
        openModal();
        return;
      }

      if (e.target.closest('[data-wishlist-close]')) {
        e.preventDefault();
        closeModal();
      }
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && !modal.hidden) {
      closeModal();
    }
  });

  // Tell our own mailer that this signup came from the wishlist, so this person
  // can be told apart from every other newsletter signup later on.
  //
  // This does NOT subscribe them, and it is not what gets their consent. The
  // consent is the ticked box on the form below, which goes to Shopify through
  // Shopify's own customer form, and the mailer reads it back from there. This
  // call only carries the label. Until 30 September 2026 the same line posted
  // straight to a Klaviyo list; the account is being retired.
  //
  // Fire-and-forget: saving the wishlist must never wait on a network call.
  function recordWishlistSignup(email, name, product) {
    if (!email) return;
    var body = { email: email, first_name: name || '' };
    if (product) {
      // Which product, so the shop can answer "who wants that bed". Until
      // today this was never sent anywhere by anybody: the heart wrote to this
      // browser's own storage and stopped there, so a saved product was
      // invisible to the shop and was lost when the visitor changed device.
      body.product = {
        handle: product.handle || '',
        title: product.title || '',
        url: product.url || '',
        image: product.img || '',
        price: product.price || ''
      };
    }
    try {
      // text/plain keeps this a simple request, so the browser sends it without
      // a preflight round trip first.
      fetch('https://nieuwsbrief.elawonen.nl/t/wishlist', {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify(body)
      }).catch(function () {});
    } catch (err) {}
  }

  function handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    if (submitBtn) submitBtn.disabled = true;

    var formData = new FormData(form);
    var signupEmail = formData.get('contact[email]');

    // pendingProduct is the one whose heart opened this modal, and it is
    // cleared by closeModal() further down, so it has to be read here.
    recordWishlistSignup(signupEmail, formData.get('contact[first_name]'),
                         pendingProduct);

    fetch(form.action, {
      method: 'POST',
      body: formData,
      headers: { Accept: 'text/html' }
    })
      .then(function () {
        finishSignup();
      })
      .catch(function () {
        // Wishlist itself is local-storage based, so don't block saving the
        // product locally just because the customer-signup network call failed.
        finishSignup();
      })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });

    function finishSignup() {
      setLead(signupEmail);
      if (pendingProduct) {
        addToWishlist(pendingProduct);
        var heart = document.querySelector(
          '.ela-wishlist-heart[data-handle="' + pendingProduct.handle + '"]'
        );
        if (heart) setHeartState(heart, true);
      }
      form.reset();
      closeModal();
    }
  }

  function init() {
    refreshHeartStates(document);
    // Bind the form submit handler up front, not lazily on first open.
    getModalEls();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Product cards can be injected later (e.g. the "load more" button on
  // collection pages), so watch for new hearts and set their initial state.
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.ela-wishlist-heart')) {
          setHeartState(node, isWishlisted(node.dataset.handle));
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('.ela-wishlist-heart').forEach(function (btn) {
            setHeartState(btn, isWishlisted(btn.dataset.handle));
          });
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

